<template>
  <div v-if="list && list.length !== 0" v-loading="loading" class="home-block mt20 shop-manage-block">
    <div class="home-block-title-box">
      <p class="home-block-title">
        我的资产
        <el-tooltip content="授权给我的资产" placement="right">
          <i class="el-icon-question-outline info-tip"></i>
        </el-tooltip>
      </p>
    </div>
    <div class="shop-manage-box" :class="{isOpen: isOpen}">
      <div v-for="(shopItem, shopIndex) in list" :key="shopIndex" class="shop-manage-item">
        <div class="top-info">
          <p class="shop-name elip" :title="shopItem.assetName">{{ shopItem.assetName }}</p>
          <div class="shop-type-tag" :class="{orange: shopItem.assetType === 2}"><span>{{ shopItem.assetType === 1 ? '直营' : '代运营' }}店铺</span></div>
        </div>
        <p class="shop-info mb10">商家类型：{{ shopItem.businessType | formateBusinessType }}</p>
        <p class="shop-info mb10">授权账号：{{ shopItem.assetAccount }}</p>
        <p v-if="shopItem.assetType === 2" class="shop-info">授权时间：{{ shopItem.authStartTime }} - {{ shopItem.authEndTime }}</p>
        <div class="shop-manage-btn" :clstag="'pageclick|keycount|home|manage_shop_'+Number(shopIndex+1)+'_'+shopItem.businessId" @click="switchShop(shopItem)">管理店铺</div>
      </div>
    </div>
    <p v-if="list.length > 4" class="show-more-shop" :clstag="`pageclick|keycount|home|manage_${isOpen ? 'moreClose' : 'moreOpen'}`" @click="isOpen = !isOpen">{{ isOpen ? '收起更多' : '查看更多' }}<i class="iconfont icon-arrow-icon down" :class="{up: isOpen}"></i></p>
  </div>
</template>

<script>
import { employeeAssetlist } from '@/api/apis/staff';
import {
  changeShop,
  sessionSave,
  nplogin,
} from '@/api/apis/switchShop';
import { isJMSupportQY } from '../../../utils/jmsdk';

export default {
  name: 'ShopManage',
  components: {
  },
  filters: {
    formateBusinessType(businessType) {
      const list = {
        110: '全渠道',
        200: 'POP',
        300: '供应商',
      };
      if (typeof businessType !== 'undefined') {
        return list[businessType];
      }
      return '--';
    },
  },
  data() {
    return {
      loading: false,
      list: [],
      isOpen: false, // 是否展示超出店铺数量
      eid: null, // 设备指纹
      noLoginToken: null, // 免登token
      vendorToken: null, // 会话token
    };
  },
  created() {
    this.getEid();
    this.getShopList();
  },
  methods: {
    // 获取设备指纹
    getEid() {
      try {
        window.getJdEid((eid) => {
          this.eid = eid;
        });
      } catch (e) {
        console.error('获取设备指纹失败！');
      }
    },
    // 获取店铺列表
    async getShopList() {
      const res = await employeeAssetlist();
      const {
        // eslint-disable-next-line no-unused-vars
        code, data, message, subErrors,
      } = res;
      this.loading = false;
      if (code === 200) {
        this.list = data.content || [];
      } else {
        this.$message.error(message || '获取店铺列表失败');
      }
    },
    // 切店
    async switchShop(shopItem) {
      // 如果是在京麦客户端中，且京麦支持企业账号，则使用京麦的切店 jssdk
      if (isJMSupportQY) {
        window.jmsdkPC.switchShop({
          vendorId: shopItem.businessId,
          pin: shopItem.assetAccount,
          vendorType: shopItem.businessType,
        });

        return;
      }

      this.loading = true;
      const params = {
        eid: this.eid,
        vendorId: shopItem.businessId,
        vendorPin: shopItem.assetAccount,
        vendorType: shopItem.businessType,
      };
      // 接口逻辑：
      // 1-1 code 10 当前店铺未授权，请联系管理员授权，（需要提示商家）
      // 1-2 code 10 店铺账号已被停用，请联系管理员处理，(需要提示商家)
      // 1-3 code 10 账号冻结，请联系客服（400-606-5500）进行处理 (需要提示商家)
      // 1-4 code 10 账号因安全临时被锁，请将账号和联系方式发送到shensu@jd.com等待处理（需要提示商家）
      // 1-5 code 10 ip在黑名单，IP服务受限，请联系客服（400-606-5500）进行处理（需要提示商家）
      // 1-6 code 11 服务器繁忙，请稍后重试！（需要提示商家）
      const res = await changeShop(params);
      const {
        // eslint-disable-next-line no-unused-vars
        code, data, message, subErrors,
      } = res;
      if (code === 200) {
        this.noLoginToken = data.noLoginToken;
        this.vendorToken = data.vendorToken;
        this.loading = false;
        this.setCookie(shopItem);
      } else if ([10, 11].includes(code)) {
        this.$alert(message || '账号异常', {
          callback: () => {
            this.loading = false;
          },
        });
      } else {
        this.loading = false;
        this.$message.error(message || '系统繁忙请重试');
      }
    },
    // 下发免登
    async setCookie(shopItem) {
      this.loading = true;
      const params = {
        eid: this.eid,
        from: 'pop_login',
        t: this.noLoginToken,
      };
      // code 100 成功
      // code 0 服务器繁忙，请稍后重试！（需要提示商家）
      const res = await nplogin(params);
      const {
        // eslint-disable-next-line no-unused-vars
        code, msg,
      } = res;
      if (Number(code) === 100) {
        this.saveTalk(shopItem);
      } else {
        this.$message.error(msg || '下发免登失败，请稍后重试');
      }
      this.loading = false;
    },
    // 保存会话
    async saveTalk(shopItem) {
      this.loading = true;
      const params = {
        vendorId: shopItem.businessId,
        vendorType: shopItem.businessType,
        vendorToken: this.vendorToken,
      };
      // code=200，接口访问成功，跳转至重定向url。
      // code=12，接口访问失败，需要弹框提示（message）商家，商家点击”知道了“，跳转至重定向url
      const res = await sessionSave(params);
      const {
        // eslint-disable-next-line no-unused-vars
        code, data, message, subErrors,
      } = res;
      if (code === 200) {
        this.loading = false;
        window.open(data.redirectUrl);
      } else if ([12].includes(code)) {
        this.$alert(message || '账号异常', {
          callback: () => {
            window.location = data.redirectUrl;
          },
        });
      } else {
        this.loading = false;
        this.$message.error(message || '保存会话失败，请稍后重试');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.shop-manage-block {
  text-align: center;
}
.shop-manage-box {
  margin-top: 30px;
  max-height: 199px;
  display: flex;
  flex-wrap: wrap;
  overflow: hidden;
  &.isOpen {
    max-height: none;
  }
  .mb10 {
    margin-bottom: 10px;
  }
  .shop-manage-item:nth-child(4n) {
    margin-right: 0;
  }
  .shop-manage-item {
    position: relative;
    margin-right: 20px;
    margin-bottom: 20px;
    padding: 18px 14px 70px 20px;
    width: 235px;
    font-size: 12px;
    color: rgba(0,0,0,0.85);
    line-height: 12px;
    border: 1px solid rgba(0,0,0,0.09);
    border-radius: 8px;
    box-sizing: border-box;
    text-align: left;
    &:hover {
      box-shadow:  0px 4px 8px 0px rgba(0,0,0,0.09);
    }
  }
  .top-info {
    margin-bottom: 13px;
    display: flex;
    align-items: center;
    .shop-name {
      max-width: 120px;
      font-size: 14px;
      line-height: 20px;
      color: rgba(0,0,0,0.85);
      font-weight: 600;
    }
    .shop-type-tag {
      margin-left: 10px;
      padding: 0 0px;
      height: 16px;
      line-height: 14px;
      border: 1px solid rgba(250,67,80,1);
      border-radius: 6px 2px 6px 2px;
      box-sizing: border-box;
      span {
        display: block;
        font-size: 12px;
        transform: scale(0.83);
        color: rgba(250,67,80,1);
      }
      &.orange {
        border-color: #FF9000;
        span {
          color: #FF9000;
        }
      }
    }
  }
  .shop-manage-btn {
    position: absolute;
    bottom: 20px;
    left: 20px;
    width: 78px;
    height: 30px;
    line-height: 28px;
    color: rgba(77,128,240,1);
    border: 1px solid rgba(77,128,240,1);
    border-radius: 15px;
    box-sizing: border-box;
    text-align: center;
    cursor: pointer;
    &:hover {
      color: #fff;
      background: rgba(77,128,240,1);
    }
  }

}
.show-more-shop {
  display: inline-block;
  padding-top: 10px;
  font-size: 14px;
  line-height: 14px;
  color: rgba(0,0,0,0.65);
  text-align: center;
  cursor: pointer;
  &:hover {
    color: #4d80f0;
    i {
      color: #4d80f0;
    }
  }
  .down {
    display: inline-block;
    position: relative;
    top: 1px;
    color: rgba(0,0,0,0.65);
    transform: rotate(90deg);
    &.up {
      transform: rotate(-90deg);
    }
  }
}
.home-block-title .info-tip {
  color: #9ca7b6;
}
</style>
